import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { BlockchainService } from "../blockchain.service";

@Component({
  selector: "app-create-asset",
  templateUrl: "./create-asset.component.html",
  styleUrls: ["./create-asset.component.scss"],
})
export class CreateAssetComponent implements OnInit {
  sources: any[] = [];
  selectedSource: any = "";
  customSource: any = "";

  types: any[] = [];
  selectedType: any = "";
  customType: any = "";

  metaData: any = "";
  fileUploadVisible: boolean = true;

  response: any = null;
  fileObj: any = null;

  constructor(
    private _snackBar: MatSnackBar,
    private blockchainService: BlockchainService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    console.log(JSON.stringify(JSON.stringify({ personName: "TEST" })));

    this.setSources();
    this.setTypes();
  }

  setSources() {
    this.sources = ["Registration", "Application", "Payment", "Grievance", "Other"];
  }

  setTypes() {
    this.types = [
      "Self AADHAR",
      "Self PAN",
      "Central Govt. Emp.",
      "State Govt. Emp.",
      "MHADA Emp.",
      "Domicile",
      "Address",
      "Caste Certificate",
      "Caste Validity",
      "Self ITR",
      "Self Income Certificate",
      "Family Income Certificate",
      "Spouse AADHAR",
      "Spouse PAN",
      "Spouse Income Certificate",
      "Spouse ITR",
      "Artist",
      "Journalist",
      "Ex Serviceman",
      "Defence Family",
      "MP/MLA/MLC",
      "Physically Handicap",
      "Freedom Fighter or Heir of Freedom Fighter",
      "PMAY",
      "Other",
    ];
  }

  fileUpload() {
    document.getElementById("fileupload").click();
  }

  extention: any = "";
  fileName: any = "";
  async handleFileInput(event: any) {
    this.fileObj = null;
    // this.selectedImage = '';
    // this.fileUploadVisible = false;
    const files = event.target.files[0];
    console.log(files);
    console.log(files.name);
    this.fileName = files.name;
    this.extention = files.name.substring(files.name.lastIndexOf(".") + 1, files.name.length);
    // convert files to base64string
    const reader = new FileReader();
    reader.readAsDataURL(files);
    reader.onload = () => {
      this.fileObj = reader.result;
    };
  }

  // async base64ToBlob(base64Image: any) {
  //   let data = base64Image.split("data:image/png;base64,");
  //   const byteString = window.atob(data[1]);
  //   const arrayBuffer = new ArrayBuffer(byteString.length);
  //   const int8Array = new Uint8Array(arrayBuffer);
  //   for (let i = 0; i < byteString.length; i++) {
  //     int8Array[i] = byteString.charCodeAt(i);
  //   }
  //   const blob = new Blob([int8Array], { type: "image/jpg" });
  //   let fileName = "ILMS_" + new Date().getTime() + ".jpg";
  //   const imageFile = new File([blob], fileName, { type: "image/jpg" });
  //   this.fileUploadVisible = false;
  //   this.fileObj = imageFile;
  //   console.log(this.fileObj);
  // }

  async createAsset() {
    let source = "";
    if (this.selectedSource == "Other") {
      source = this.customSource;
    } else {
      source = this.selectedSource;
    }

    let type = "";
    if (this.selectedType == "Other") {
      type = this.customType;
    } else {
      type = this.selectedType;
    }

    const progressSpinnerDialog = await this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    this.fileUploadVisible = false;
    this.response = null;
    this.blockchainService
      .createAsset(
        this.fileObj,
        source,
        type,
        JSON.stringify(JSON.stringify(this.metaData)),
        this.extention,
        this.fileName
      )
      .subscribe((data) => {
        progressSpinnerDialog.close();
        this.fileObj = null;
        this.selectedSource = "";
        this.selectedType = "";
        this.metaData = "";
        this.fileUploadVisible = true;
        this.fileName = "";
        this.extention = "";
        if (!data.error) {
          if (data.includes("id")) {
            this.fileObj = null;
            this.selectedSource = "";
            this.selectedType = "";
            this.metaData = "";
            this.fileUploadVisible = true;
            this.fileName = "";
            this.extention = "";
            console.log(data);
            this.response = JSON.parse(data);
            console.log(this.response);

            this._snackBar.open("Asset created successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3000,
            });
          } else {
            this._snackBar.open(data, "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3000,
            });
            return;
          }
        } else {
          this._snackBar.open(data.error, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3000,
          });
          return;
        }
      });
  }
}
